import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsMessagingAppsRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsMessagingAppsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { HelpCenterSettingsMessagingAppsEntryPoint } from './ui/messaging-apps/messagingApps.tsx';

export const helpCenterSettingsMessagingAppsRouteEntry: Route = createEntry(
	helpCenterSettingsMessagingAppsRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.messaging-apps',
		layout: globalLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		entryPoint() {
			return fg('csm-omni-whatsapp-support')
				? HelpCenterSettingsMessagingAppsEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getServiceDeskNavigationResources(),
			serviceDeskContextResource,
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
